var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3821_64456)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8715 4.09439C18.3744 2.62144 15.9699 2.63053 14.4839 4.11475L12.3844 6.21185C12.3527 6.23668 12.3221 6.2637 12.2929 6.29289C12.264 6.32181 12.2372 6.35205 12.2126 6.38343L5.30961 13.2761C5.24212 13.3404 5.18306 13.4147 5.13499 13.4977C5.09721 13.5627 5.06736 13.631 5.04544 13.7013L4.05694 16.6668C4.05314 16.6775 4.04953 16.6884 4.0461 16.6993L3.05134 19.6836C2.93157 20.0429 3.02509 20.4391 3.29292 20.7069C3.56075 20.9747 3.95692 21.0682 4.31626 20.9485L10.2937 18.956C10.3878 18.9272 10.4786 18.8841 10.5625 18.8269C10.6195 18.7882 10.6718 18.744 10.7188 18.6953L19.8928 9.5285C21.3965 8.02575 21.387 5.58535 19.8715 4.09439ZM7.266 17.857L9.46014 17.1257L15.5884 11.0026L13.0048 8.41896L6.87392 14.5404L6.1441 16.7299L7.20714 17.7929C7.22786 17.8136 7.24748 17.835 7.266 17.857ZM14.4198 7.00557L17.0031 9.58883L18.479 8.11384C19.1968 7.39655 19.1922 6.23172 18.4689 5.52007C17.7543 4.81701 16.6066 4.82135 15.8973 5.52979L14.4198 7.00557Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3821_64456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.92776a3e98dc7ec0129b7d343064d289.svg";
export { ForwardRef as ReactComponent };